@if(canMakePayment)
{
<div nestableForm name="form">
  <div class="apple-pay-button btn" (click)="applePay()"
       aria-label="Pay with Apple Pay">
    <span class="apple-logo" aria-hidden="true"></span>
    <span class="sr-only">Pay with Apple Pay</span>
  </div>
</div>
}
